import axios from 'axios';

// Assumes axios.defaults.baseURL is set in App.js
const API_URL = '/api/users/';
const AUTH_API_URL = '/api/auth/';

const signup = (email, password, firstName, lastName, mobileNumber) => {
    return axios.post(AUTH_API_URL + 'signup', {
        email,
        password,
        user_first_name: firstName,
        user_last_name: lastName,
        mobile_phone_number: mobileNumber,
    });
};

const login = (email, password) => {
    const params = new URLSearchParams();
    params.append('username', email);
    params.append('password', password);

    return axios.post(AUTH_API_URL + 'login', params, {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
    }).then((response) => {
        if (response.data.access_token) {
            localStorage.setItem('user', JSON.stringify(response.data));
        }
        return response.data;
    });
};

const logout = () => {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
};

const getCurrentUser = () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
};

const getToken = () => {
    return localStorage.getItem('token');
};

const updateUser = (firstName, lastName, mobileNumber) => {
    return axios.put(API_URL + 'me', {
        user_first_name: firstName,
        user_last_name: lastName,
        mobile_phone_number: mobileNumber,
    });
};

const changePassword = (oldPassword, newPassword, confirmNewPassword) => {
    return axios.put(API_URL + 'me/password', {
        old_password: oldPassword,
        new_password: newPassword,
        confirm_new_password: confirmNewPassword,
    });
};

const authService = {
    signup,
    login,
    logout,
    getCurrentUser,
    updateUser,
    changePassword,
};

export default authService;
